import CloseIcon from '@mui/icons-material/Close';
import { Dialog, styled, Box as MuiBox } from '@mui/material';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.primary.main,
    border: `0.0625rem solid ${theme.palette.common.white}`,
    borderRadius: '0.375rem',
    width: '100%',
    maxWidth: '37.5rem',
    padding: '1.5rem',
  },
}));

export const Content = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  gap: '1.5rem',
  alignItems: 'center',
  height: '100%',
}));

export const RowCounter = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.75rem',
  alignItems: 'center',

  [theme.breakpoints.down('sm')]: {
    marginLeft: '0.5rem',
  },
}));

export const CloseBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignSelf: 'flex-end',
}));

export const CloseIconStyled = styled(CloseIcon)(({ theme }) => ({
  cursor: 'pointer',
  color: theme.palette.common.white,
  '&:hover': {
    color: theme.palette.grey[600],
  },
}));

export const StyledTimerBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  color: theme.palette.common.white,
  backgroundColor: theme.palette.primary.light,
  width: '25rem',
  padding: '1rem',
  borderRadius: '0.5rem',
  boxSizing: 'border-box',
  gap: '1rem',
  [theme.breakpoints.down('sm')]: {
    width: '20rem',
  },
}));

export const TextContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: 'auto',
});

export const TextBlock = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  flex: '0 1 auto',
});

export const TextOpacity = styled('div')({
  opacity: '0.5',
  wordBreak: 'break-all',
});

export const ScrollableArea = styled(MuiBox)(({ theme }) => ({
  flexGrow: 1,
  overflowY: 'auto',
  paddingBottom: theme.spacing(2),
  paddingTop: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minHeight: 0,
  width: '100%',
}));

export const StyledCodeBox = styled(MuiBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  border: `0.0625rem solid ${theme.palette.common.white}`,
  width: '25rem',
  padding: '1rem',
  borderRadius: '1rem',
  boxSizing: 'border-box',
  gap: '1rem',
  marginTop: '1.5rem',
  marginBottom: '1.5rem',
  [theme.breakpoints.down('sm')]: {
    width: '20rem',
  },
}));

export const ImageStyled = styled('img')({
  flexShrink: 0,
  borderRadius: '0.25rem',
  height: '15rem',
  display: 'flex',
  marginTop: '1.5rem',
});

export const Icon = styled('img')(() => ({
  width: '9.5rem',
}));
